import { RouteComponentProps } from 'react-router';
import { environment } from '../config/environment';

export interface UTMInfo {
    utmSource?: string;
    utmMedium?: string;
    utmCampaign?: string;
}

export class UrlService {
    public static buildAbsoluteUrl(routerProps: RouteComponentProps) {
        return environment.PROD_HOST + routerProps.location.pathname.toLowerCase();
    }

    public static getCustomVersionParam(routerProps: RouteComponentProps) {
        const search = new URLSearchParams(routerProps.location.search);

        return search.get('version') || null;
    }

    public static getGameCustomApi(routerProps: RouteComponentProps) {
        const search = new URLSearchParams(routerProps.location.search);

        return search.get('gameApi') || null;
    }
    
    public static getReferrerIfOuter(): string | undefined {
        const refDirect = window.document.referrer === '';

        if (!refDirect && window.document.referrer.indexOf(window.location.host) === -1 ) {
            return window.document.referrer;
        }
    }

    public static getUtmInfo(): UTMInfo {
        const search = new URLSearchParams(window.location.search);

        return {
            utmSource: search.get('utm_source') || undefined,
            utmMedium: search.get('utm_medium') || undefined,
            utmCampaign: search.get('utm_campaign') || undefined
        } as UTMInfo;
    }

    public static getPageType(): string {
        const url = window.location.pathname || '';
        const ROUTES = {
            'all-games': 'All games page',
            'category': 'Category page',
            'profile': 'Profile page',
            'search': 'Search page',
            'games': 'Game page',
            'help': 'Help page',
            '404': '404 page'
        };

        for (const route in ROUTES) {
            if (url.indexOf(route) !== -1) {
                return ROUTES[route];
            }
        }

        return 'Home page';
    }

    static getCurrentPage(): string {
        const location = window.location.pathname || '';

        if (location.indexOf('/games/') !== -1) {
            return 'game start';
        } else if (location.indexOf('all-games') !== -1) {
            return 'category/allgames';
        } else if (location.indexOf('profile') !== -1) {
            return 'profile';
        } else if (location.indexOf('search') !== -1) {
            return 'search';
        } else if (location.indexOf('category') !== -1) {
            return location.substr(1);
        } else if (location.indexOf('help') !== -1) {
            return 'help';
        }

        return 'arena home';
    }

    static get domain() {
        return window.location.host;
    }
}
